import React, { Component } from "react";
import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import { Div, Row, Col, Text } from "atomize";

export default class CampaignPoints extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div>
            <Div d="flex" flexDir={{xs: "column", md: "row"}} flexWrap="wrap">
              {content.map((data, index) => {
                return (
                  <Div
                    key={index}
                    bg="#1F1F1F"
                    p={{t: {xs: "2.375rem", md: "1.6rem"}, x: "1.6rem", b: {xs: "1.56rem", md: "2rem"}}}
                    style={{
                      marginBottom: ".2rem",
                      borderRight: "2px solid black",
                    }}
                    flexGrow="1 1 33.33%"
                  >
                    <Text
                      m={{ b: ".6rem" }}
                      fontFamily="secondary"
                      textWeight="700"
                      textColor="gray700"
                    >
                      {data.count}
                    </Text>
                    <Text
                      m={{ b: ".6rem" }}
                      textSize={{xs: "subheader4", md: "subheader6"}}
                      maxW="14.125rem"
                      textWeight="700"
                      tag="h3"
                    >
                      {data.heading}
                    </Text>
                    <Text textColor="gray450" maxW={{xs: "16rem", md: "100%"}}>{data.info}</Text>
                  </Div>
                );
              })}
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
